import api from '@pray/shared/utils/api';

export type AutoFillPrayRadioSlot = {
  artistId: string;
  scheduledAt: string;
};

export type AutoFillPrayRadioSlotsResult = {
  scheduled: Array<{
    scheduled_at: string;
    artist_id: string;
    daily_item_id: string;
    content: { id: string; title: string | null };
  }>;
  failed: Array<{
    scheduled_at: string;
    artist_id: string;
    reason: string;
  }>;
};

/**
 * Runs the Pray Radio Auto pick for many assigned-but-empty calendar slots at
 * once (PB-38067). Each slot is filled from its own leader's library; the
 * backend keeps one leader's slots strictly sequential so an episode is never
 * picked twice in the batch. Partial failures return 200 with `failed` listed.
 */
export async function autoFillPrayRadioSlots({ slots }: { slots: AutoFillPrayRadioSlot[] }) {
  if (!slots?.length) throw Error('At least one slot is required');

  const url = '/web/studio/pray-radio/auto-fill';
  const response = await api.executePostRequest(url, {
    slots: slots.map((slot) => ({ artist_id: slot.artistId, scheduled_at: slot.scheduledAt })),
  });

  return response.data;
}
